export default {
    delta: {
        url: 'search/delta',
        include: ['us', 'za', 'jp', 'cn', 'ca', 'uk', 'au', 'de', 'fr', 'it', 'es', 'cis', 'sa'],
    },
    river: {
        url: 'search/river',
        include: ['us', 'za', 'jp', 'cn', 'ca', 'uk', 'au', 'de', 'fr', 'it', 'es', 'cis', 'sa'],
    },
};
